// extracted by mini-css-extract-plugin
export default {"wrapper":"AppLayout_wrapper__cqpWb","container":"AppLayout_container__ZIZR3","contentContainer":"AppLayout_contentContainer__nNiTn"};